import React from 'react';
import PropTypes from 'prop-types';
import './MyPlayLoader.scss';

const MyPlayLoader = ({ title, color })=> {
  return (
    <div className='myplay-loader'>
      <div className='myplay-loader__court' style={{ borderColor: color }}>
        <div className='myplay-loader__court__half myplay-loader__court__half--left' style={{ borderColor: color }}>
          <div className='myplay-loader__court__half__penalty-box myplay-loader__court__half__penalty-box--left' style={{ borderColor: color }}/>
        </div>
        <div className='myplay-loader__court__half myplay-loader__court__half--right' style={{ borderColor: color }}>
          <div className='myplay-loader__court__half__penalty-box myplay-loader__court__half__penalty-box--right' style={{ borderColor: color }}/>
        </div>
        <div className="myplay-loader__court__center-wrapper">
          <div className='myplay-loader__court__center-wrapper__center' style={{ backgroundColor: color }}>
            <div className='myplay-loader__court__center-wrapper__center__triangle'/>
          </div>
        </div>
      </div>
      <div className='myplay-loader__text'>
        <span>{title}</span>
        <span className='myplay-loader__text__dot'>.</span>
        <span className='myplay-loader__text__dot'>.</span>
        <span className='myplay-loader__text__dot'>.</span>
      </div>
    </div>
  );
};

MyPlayLoader.propTypes = {
  color: PropTypes.string, 
  title: PropTypes.string
};

MyPlayLoader.defaultProps = {
  color: "#000", 
  title: "Loading"
};

export default MyPlayLoader;
